import React from 'react';

const Loader = () => {
  return (
    <div className="loader-container">
      <picture>
        <source srcSet="/img/ManaCars_Logo_V1/PNG/logoM.webp" type="image/webp" />
        <img src="/img/ManaCars_Logo_V1/PNG/logoM.png" alt="Logo" className="loader-logo" />
      </picture>
      <div className="loader"></div>
    </div>
  );
};

export default Loader;